import PropTypes from 'prop-types';
import { useEffect, useState, memo } from 'react';
import { restApi } from '@icp/settings';
import { extensionCache } from '@icp/form-renderer-core';

function ImportCss(props) {
  const { url, children, manualLoad } = props;

  const [cssContent, setCssContent] = useState(null);

  useEffect(() => {
    if (!url) return;
    if (!manualLoad) return;
    extensionCache.getCache(url).then(async (cssText) => {
      if (!cssText) {
        cssText = await restApi.get(url, { responseType: 'text', noTimestamp: true });
        extensionCache.setCache(url, cssText);
      }
      setCssContent(cssText);
    });
  }, [manualLoad, url]);

  return (
    <>
      <style>{`:host(.design-mode) * { user-select: none; pointer-events: none; }`}</style>
      {url && !manualLoad ? <style>{`@import url("${url}");`}</style> : null}
      {cssContent ? <style>{cssContent}</style> : null}
      {children}
    </>
  );
}

ImportCss.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node,
  manualLoad: PropTypes.bool,
};

export default memo(ImportCss);
